import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Button,
  Paper,
  Toolbar,
  Typography,
} from '@mui/material';
import { KeyboardArrowLeft } from '@mui/icons-material';

import TranslationsContext from '../../../../components/Container/Language/TranslationsContext';
import LayoutConfigContext from '../../../../components/Smart/Layout/LayoutConfigContext';
import ManagerUserCreateForm from './Components/ManagerUserCreateForm';
import configs from '../../../../configs';

const ManagerUserCreate = (props) => {
  const navigate = useNavigate();
  const { t } = useContext(TranslationsContext);
  const { setPageConfigs } = useContext(LayoutConfigContext);

  useEffect(() => setPageConfigs({
    name: 'user',
  }), [t, setPageConfigs]);

  const toolbarProps = {
    sx: {
      pl: {
        sm: 0,
      },
      pr: {
        xs: 1,
        sm: 1,
      },
    },
  };
  const titleProps = {
    sx: {
      flex: '1 1 100%',
    },
    variant: 'h6',
    component: 'div',
  };
  const buttonProps = {
    onClick: () => navigate(`${configs.prefix || ''}/manage/user/`),
    variant: 'contained',
    startIcon: <KeyboardArrowLeft />,
    size: 'large',
    sx: {
      mr: 2,
    },
  };
  const boxProps = {
    sx: {
      p: 1,
    },
  };
  const paperProps = {
    elevation: 0,
    sx: {
      background: 'none',
      width: '100%',
      mb: 2,
    },
  };

  return (
    <>
      <Toolbar {...toolbarProps}>
        <Button {...buttonProps}>
          {t('app:common:back')}
        </Button>
        <Typography {...titleProps}>
          {t('app:controller:customer:create-user')}
        </Typography>
      </Toolbar>

      <Box {...boxProps}>
        <Paper {...paperProps}>
          <ManagerUserCreateForm {...props} />
        </Paper>
      </Box>
    </>
  );
};

export default ManagerUserCreate;
